// src/components/module/cotizaciones/CotizacionDetailPage.tsx
import React, { useState, useEffect } from 'react';
import { toast } from '../../../utils/toast';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { CotizacionDetailModal } from './CotizacionDetailModal';
import { CotizacionesApi } from '../../../services/api/CotizacionesApi';
import PageLayout from '../../../components/layout/PageLayout';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

export const CotizacionDetailPage = () => {
  const { id } = useParams();
  const [cotizacion, setCotizacion] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCotizacion();
  }, [id]);

  const loadCotizacion = async () => {
    if (!id) return;
    
    try {
      setLoading(true);
      const data = await CotizacionesApi.getCotizacionById(id);
      setCotizacion(data);
    } catch (error) {
      console.error('Error cargando cotización:', error);
      toast.error('No se pudo cargar la información de la cotización');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <PageLayout icon={RequestQuoteIcon} title="Detalle de Cotización">
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress />
        </Box>
      </PageLayout>
    );
  }

  if (!cotizacion) {
    return (
      <PageLayout icon={RequestQuoteIcon} title="Detalle de Cotización">
        <Box p={3}>
          No se encontró la cotización
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout icon={RequestQuoteIcon} title="Detalle de Cotización">
      <CotizacionDetailModal
        cotizacion={cotizacion}
        open={true}
        onClose={() => {}} // El modal no se puede cerrar en esta vista
      />
    </PageLayout>
  );
};